import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { ToastService } from '../services/toast.service';
import { describeApiError } from './api-error.util';
import { SKIP_ERROR_TOAST } from './http-context';

/**
 * - 401: the API session expired, send the user back to the login page.
 * - Anything else: show a toast with the reason, unless the caller opted out
 *   with SKIP_ERROR_TOAST because it renders the error itself.
 */
export const errorInterceptor: HttpInterceptorFn = (request, next) => {
  const router = inject(Router);
  const toast = inject(ToastService);

  return next(request).pipe(
    catchError((error: HttpErrorResponse) => {
      // The login page and the session check handle their own responses.
      const isAuthCall = /\/auth\/(login|check)$/.test(request.url);

      if (error.status === 401) {
        if (!isAuthCall && !router.url.startsWith('/login')) {
          toast.warning('Your session has ended', { message: 'Sign in again to continue.' });
          router.navigateByUrl('/login');
        }
      } else if (!isAuthCall && !request.context.get(SKIP_ERROR_TOAST)) {
        const { title, message, details } = describeApiError(error);
        toast.error(title, { message, details });
      }

      return throwError(() => error);
    }),
  );
};
